import { useTranslation } from 'react-i18next'

export default function ContactBookingSummary({ summary, centered = false }) {
  const { t } = useTranslation()
  const total = summary == null
    ? null
    : (summary.total ?? Object.values(summary.by_status ?? {}).reduce(
        (sum, count) => sum + (Number(count) || 0),
        0,
      ))

  return (
    <div
      className={`flex flex-wrap gap-1.5 mt-2 ${centered ? 'justify-center' : ''}`}
      aria-label={t('contactBookingSummary.label')}
    >
      <span className="bg-slate-100 text-slate-700 text-[11px] leading-4 px-2 py-1 rounded-full font-semibold whitespace-nowrap">
        {total ?? '—'} {t('contactBookingSummary.total')}
      </span>
    </div>
  )
}
